import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { oneOfType, array, object, string } from 'prop-types';
import Icon from 'components/icon';

export default class ModalHelper extends React.Component {
    hoursContainer() {
        if (!this.props.modalDataItems.locationOpeningHours ||
             !this.props.modalDataItems.locationOpeningHours.length) { return null; }
        return (
            <div className="hours">
                <p className="hours-title">{this.props.localHoursText}</p>
                {this.props.modalDataItems.locationOpeningHours.map((hours, i) => (
                    /* eslint-disable react/no-array-index-key */
                    // @NOTE - there is no unique id for this
                    <div key={i} className="seperateHours">
                        <p>{hours.note} {hours.dayLabel} {hours.hourLabel}</p>
                    </div>
                    /* eslint-enable react/no-array-index-key */
                ))}
            </div>
        );
    }
    additionalInformation() {
        if (this.props.modalDataItems.additionalInformationLink) {
            return (
                <a href={this.props.modalDataItems.additionalInformationLink}>
                    {ReactHtmlParser(this.props.modalDataItems.additionalInformation)}
                </a>
            );
        }
        return (ReactHtmlParser(this.props.modalDataItems.additionalInformation));
    }

    render() {
        // if (this.props.modalDataItems.length <= 0) { return null; }
        // at the minute we only have one type of react modal,
        // this might need to be broken out if there are more
        if (!this.props.modalDataItems) { return null; }
        switch (this.props.modalType) {
            case 'loader':
                return (
                    <div className="loader-modal" />
                );
            case 'location':
                return (
                    <div className="location-modal">
                        <div className="address-details">
                            <h3>{this.props.modalDataItems.title}</h3>
                            <p className="title">{this.props.modalDataItems.name}</p>
                            <p className="title">{this.props.modalDataItems.addressHeading}</p>
                            <p>{this.props.modalDataItems.address}</p>
                            {this.props.modalDataItems.phoneNumber &&
                                <a href={`tel:${this.props.modalDataItems.phoneNumber}`}><Icon glyph="phone" /> {this.props.modalDataItems.phoneNumber}</a>
                            }
                            {this.props.modalDataItems.faxNumber &&
                                <a href={`tel:${this.props.modalDataItems.faxNumber}`}><Icon glyph="fax" /> {this.props.modalDataItems.faxNumber}</a>
                            }
                            {this.props.modalDataItems.email &&
                                <a href={this.props.modalDataItems.emailLink}><Icon glyph="mail-schmal" /> {this.props.modalDataItems.email}</a>
                            }
                            {this.hoursContainer()}
                            {this.additionalInformation()}

                            {this.props.modalDataItems.ctaButtonUrl &&
                                <a href={this.props.modalDataItems.ctaButtonUrl} className="btn-skin-1 button" target="_blank"><Icon glyph="location" />{this.props.getDirectionsText}</a>
                            }
                        </div>
                        <div className="address-image" style={{ backgroundImage: `url(${this.props.modalDataItems.image})` }} ><img src={this.props.modalDataItems.image} alt="" /></div>
                    </div>
                );
            default:
                return null;
        }
    }
}


ModalHelper.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    modalDataItems: oneOfType([object, array]),
    modalType: oneOfType([string, object]),
    localHoursText: oneOfType([string, object]),
    getDirectionsText: oneOfType([string, object])
    /* eslint-enable react/no-typos */
};

ModalHelper.defaultProps = {
    modalDataItems: [],
    modalType: '',
    localHoursText: '',
    getDirectionsText: ''
};
